export default {
  setProducts(state, payload) {
    state.products = payload;
  },
  salesStockChanged(state) {
    state.salesStockRevision += 1;
  }
}
